import { GROUP_NAME as camposNovos } from "@/modules/campos_novos/settings";
import { GROUP_NAME as Julho14 } from "@/modules/julho_14/settings";
import { GROUP_NAME as FozChapeco } from "@/modules/foz_chapeco/settings";

export const GROUP_ROUTE_MAP: {
    [name: string]: string;
} = {
    [Julho14]: "julho_14",
    [FozChapeco]: "foz_chapeco",
    [camposNovos]: "campos_novos"
};
